import { render, staticRenderFns } from "./contentVideo2.vue?vue&type=template&id=121254d6&scoped=true&"
import script from "./contentVideo2.vue?vue&type=script&lang=js&"
export * from "./contentVideo2.vue?vue&type=script&lang=js&"
import style0 from "./contentVideo2.vue?vue&type=style&index=0&id=121254d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121254d6",
  null
  
)

export default component.exports